import { render, staticRenderFns } from "./GameCreation.vue?vue&type=template&id=179d9a18"
import script from "./GameCreation.vue?vue&type=script&lang=js"
export * from "./GameCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.10.0_vue-template-compiler@2.7.16_webpack@5.90.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports